import { render, staticRenderFns } from "./userscore.vue?vue&type=template&id=4dcc4402&scoped=true"
import script from "./userscore.vue?vue&type=script&lang=js"
export * from "./userscore.vue?vue&type=script&lang=js"
import style0 from "./userscore.vue?vue&type=style&index=0&id=4dcc4402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc4402",
  null
  
)

export default component.exports